export enum ParamEvent {
	VISIBLE_UPDATED = 'param_visible_updated',
	// UPDATED = 'param_updated',
	RAW_INPUT_UPDATED = 'raw_input_updated',
	VALUE_UPDATED = 'param_value_updated',
	EXPRESSION_UPDATED = 'param_expression_update',
	ERROR_UPDATED = 'param_error_updated',
	DELETED = 'param_deleted',
}
